/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


 // SITE SCROLLER
jQuery(document).ready(function($){
   $(window).scroll(function(){    
		if($(this).scrollTop()>800){
        	$("#site-scroll").fadeIn();
      	} else {
        	$("#site-scroll").fadeOut();
      	}
    });
  
   $("#site-scroll").click(function() {
    $("html, body").animate({ scrollTop: 0 }, 1000);
    return false;
  }); 
  
  if ($('#mob_header__icon-bar').length > 0) {
    $('#mob_header__icon-bar').slick({
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      easing: 'linear',
      autoplay: true,
      autoplaySpeed: '5000'
    });
  }
  
  if ($('#shopify-section-page-contact-template #contact_nav').length > 0) {
    $('#contact_nav li').click(e => {
      $('#contact_nav li').removeClass('nav_show');
      $('#contact_info ul').removeClass('info_show');
      e.target.classList.add('nav_show');
      const data = e.target.getAttribute('data');
      $(`#contact_info ul[data=${data}]`).addClass('info_show');
    });
  }

    
});